// extracted by mini-css-extract-plugin
export default {"container":"q1zsM9p2V4"};